// IMPORT ACTIONS

import { GET_USER_ROLES, UPSERT_USER_ROLE, GET_USER_ROLE, GET_USERS_FOR_ROLE, SET_USERS_FOR_ROLE, GET_ROLES_FOR_USER } from "../constants/action-types";

const initialState = {
    userRoles: {},
    currentUserRole: {},
    currentUsers: {},
    currentRolesForUser: {}
}

export const UserRoleReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_USER_ROLES: {
            const incomingUserRoles = action.payload
            const userRoles = {}

            incomingUserRoles.forEach(role => {
                userRoles[role.id] = role
            });

            return {
                ...state,
                userRoles: userRoles
            };
        }

        case GET_USER_ROLE: {
            const incomingUserRoleId = action.payload
            var currentUserRole = state.userRoles[incomingUserRoleId]

            if (currentUserRole == null) {
                currentUserRole = {}
            }

            return {
                ...state,
                currentUserRole: currentUserRole
            }
        }

        case GET_USERS_FOR_ROLE: {
            const incomingUsers = action.payload
            const currentUsers = {}

            incomingUsers.forEach(user => {
                currentUsers[user.id] = user
            });

            return {
                ...state,
                currentUsers: currentUsers
            }
        }

        case GET_ROLES_FOR_USER: {
            const incomingRoles = action.payload
            const currentRolesForUser = {}

            incomingRoles.forEach(role => {
                currentRolesForUser[role.id] = role
            });

            return {
                ...state,
                currentRolesForUser: currentRolesForUser
            }
        }

        default:
            return state;
    }
}